<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <div class="card-header-actions" style="text-align: right; padding-top: 2px;">
            <CButton color="danger" size="sm" @click="resetChallengerModal()" style="margin-right: 5px;" v-if="challenge.type != 'video'" v-show="permissions && permissions['challenges.write'] === true">Resetear Concurso</CButton>
            <CButton color="warning" size="sm" @click="checkWinnersModal()" style="margin-right: 5px;" v-if="challenge.type != 'video' && tab == 'entries'" v-show="permissions && permissions['challenges.write'] === true">{{has_validated ? 'Recalcular' : 'Calcular'}} Ganadores</CButton>
            <CButton color="success" size="sm" @click="validationsModal()" style="margin-right: 5px;" v-if="challenge.type != 'video' && tab == 'entries' && has_pendings" v-show="permissions && permissions['challenges.write'] === true">Autorizar Puntos</CButton>
            <CButton color="info" size="sm" @click="showDashboard()" style="margin-right: 5px;">Ver Dashboard</CButton>
          </div>
          <h3 style="margin-bottom: 0px;">{{challenge.code}} - {{challenge.name}}</h3>
        </slot>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol md="12">
            <div class="card-header-actions" style="text-align: right; height: 10px;">
              <span v-if="challenge.type == 'boxes'"><br />{{(challenge.mechanic == 'total' ? 'Número Total de Cajas Vendidas' : challenge.mechanic == 'ranges' ? 'Rangos de Cajas Vendidas' : 'Individual por cada Caja Vendida')}}</span>
              <span v-if="challenge.type == 'sales'"><br />{{(challenge.mechanic == 'total' ? 'Total de Ventas' : challenge.mechanic == 'ranges' ? 'Rangos de Ventas' : 'Individual por cada Monto Vendido')}}</span>
              <span v-if="challenge.type == 'customers'"><br />{{(challenge.mechanic == 'total' ? 'Número Total de Clientes Alcanzados' : challenge.mechanic == 'ranges' ? 'Rangos de Clientes Alcanzados' : 'Individual por cada Cliente Alcanzado')}}</span>
            </div>
            <br />
            <ul class="nav nav-tabs justify-content-begin">
              <li @click="changeTab('info')" class="nav-item">
                <a class="nav-link" :class="tab == 'info' ? 'active' : ''" aria-current="page">Información</a>
              </li>
              <li @click="changeTab('rules')" class="nav-item">
                <a class="nav-link" :class="tab == 'rules' ? 'active' : ''">Dinámica</a>
              </li>
              <li v-if="challenge.type != 'video'" @click="changeTab('products')" class="nav-item">
                <a class="nav-link" :class="tab == 'products' ? 'active' : ''">Productos</a>
              </li>
              <li v-if="challenge.type == 'customers' || challenge.type == 'boxes_and_customers' || challenge.type == 'objectives'" @click="changeTab('customers')" class="nav-item">
                <a class="nav-link" :class="tab == 'customers' ? 'active' : ''">Clientes</a>
              </li>
              <li v-if="challenge.type != 'video'" @click="changeTab('sales')" class="nav-item">
                <a class="nav-link" :class="tab == 'sales' ? 'active' : ''">Ventas</a>
              </li>
              <li v-if="challenge.type == 'video'" @click="changeTab('quest')" class="nav-item">
                <a class="nav-link" :class="tab == 'quest' ? 'active' : ''">Cuestionario</a>
              </li>
              <li v-if="challenge.type != 'objectives'" @click="changeTab('awards')" class="nav-item">
                <a class="nav-link" :class="tab == 'awards' ? 'active' : ''">Premios</a>
              </li>
              <li @click="changeTab('entries')" class="nav-item">
                <a class="nav-link" :class="tab == 'entries' ? 'active' : ''">Participantes</a>
              </li>              
            </ul>
          </CCol>
        </CRow>
        <CRow>
          <CCol md="12">
            <CCard v-show="tab == 'info'">
              <CCardBody>
                <div style="float: right; text-align: right;" v-show="challenge.type == 'video'">
                  <div v-for="(video, index) in challenge.videos"><a :href="'https://www.youtube.com/watch?v='+video.youtube_reference" target="_blank">https://www.youtube.com/watch?v={{video.youtube_reference}}</a></div>
                  <br />
                </div>
                <CRow>
                  <CCol md="12">
                    <CRow>
                      <CCol md="12">
                        <b>Tipo: </b>
                          {{
                            challenge.type == 'video' ?
                              'Capacitación' : 
                              (challenge.type == 'sales' ?
                                'Ventas Mínimas' : 
                                (challenge.type == 'customers' ? 
                                  'Clientes Mínimos' : 
                                  challenge.type == 'boxes' ? 
                                    'Cajas Mínimo' : 
                                    (challenge.type == 'boxes_and_customers' ? 
                                      'Cajas & Clientes' :
                                      (challenge.type == 'objectives') ? 
                                      'Objetivos' :'-'
                                    )
                                )
                              )
                          }}
                          <br /><br />
                      </CCol>
                    </CRow> 
                    <CRow>
                      <CCol md="12" v-if="challenge.type == 'boxes' && challenge.mechanic != 'normal'">
                        <b>Mécanica: </b>{{challenge.mechanic == 'total' ? 'Total de Cajas Vendidas' : (challenge.mechanic == 'ranges' ? 'Rangos de Cajas Vendidas' : (challenge.mechanic == 'individual' ? 'Individual por cada Caja Vendida' : ''))}}<br /><br />
                      </CCol>
                      <CCol md="12" v-if="challenge.type == 'sales' && challenge.mechanic != 'normal'">
                        <b>Mécanica: </b>{{challenge.mechanic == 'total' ? 'Total de Ventas' : (challenge.mechanic == 'ranges' ? 'Rangos de Ventas' : '')}}<br /><br />
                      </CCol>
                      <CCol md="12" v-if="challenge.type == 'customers' && challenge.mechanic != 'normal'">
                        <b>Mécanica: </b>{{challenge.mechanic == 'total' ? 'Total de Clientes Alcanzados' : (challenge.mechanic == 'ranges' ? 'Rangos de Clientes Alcanzados' : (challenge.mechanic == 'individual' ? 'Individual por cada Cliente Alcanzado' : ''))}}<br /><br />
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol md="12">
                        <b>Nombre: </b>{{challenge.name}}
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol md="12">
                        <b>Descripción: </b>{{challenge.description}}<br /><br />
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol md="12">
                        <b>Fecha de Inicio: </b>{{challenge.start_date | date}}
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol md="12">
                        <b>Fecha de Termino: </b>{{challenge.end_date | date}}
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
            <CCard v-show="tab == 'products'">
              <CCardBody>
                <CRow>
                  <CCol md="12">
                    <ChallengeProducts
                      :items="products"
                      :challenge="challenge"
                      :fields="product_fields"
                      hover
                      striped
                      border
                      small
                      fixed
                      caption="Productos Participantes"
                      @refresh="refreshProducts"
                      :permissions="permissions"
                    />
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
            <CCard v-show="tab == 'sales' && challenge.type != 'video'">
              <CCardBody>
                <CRow>
                  <CCol md="12">
                    <ChallengeSales
                      ref="refChallengeSales"
                      :fields="sales_fields"
                      hover
                      striped
                      border
                      small
                      fixed
                      caption="Ventas Participantes"
                      :permissions="permissions"
                    />
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
            <CCard v-show="tab == 'quest' && challenge.type == 'video'">
              <CCardBody>
                <CRow>
                  <CCol md="12">
                    <ChallengeQuest
                      :items="questions"
                      :challenge="challenge"
                      hover
                      striped
                      border
                      small
                      fixed
                      caption="Preguntas"
                      @refresh="refreshQuestions"
                      :permissions="permissions"
                    />
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
            <CCard v-show="tab == 'cedis' && challenge.type == 'video'">
              <CCardBody>
                <CRow>
                  <CCol md="12">
                    CEDIS
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
            <CCard v-show="tab == 'entries'">
              <CCardBody>
                <CRow>
                  <CCol md="12">
                    <ChallengeEntries
                      :items="entries"
                      :challenge="challenge"
                      :fields="fields"
                      hover
                      striped
                      border
                      small
                      fixed
                      caption="Participantes"
                      @refresh="refreshEntries"
                      @filtered="refreshEntries"
                      :permissions="permissions"
                    />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="12">
                    <ChallengeAvailable
                      :items="availables"
                      :challenge="challenge"
                      hover
                      striped
                      border
                      small
                      fixed
                      caption="¿Quienes pueden participar?"
                      @refresh="refreshAvailables"
                      @filtered="refreshAvailables"
                      :permissions="permissions"
                    />
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
            <CCard v-show="tab == 'customers'">
              <CCardBody>
                <CRow>
                  <CCol md="12">
                    <ChallengeCustomers
                      :items="customers"
                      :challenge="challenge"
                      hover
                      striped
                      border
                      small
                      fixed
                      caption="Clientes"
                      @refresh="refreshCustomers"
                      @filtered="refreshCustomers"
                      :permissions="permissions"
                    />
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
            <CCard v-show="tab == 'rules'">
              <CCardBody>
                <CRow>
                  <CCol v-if="challenge.type != 'objectives'" md="12">
                    <ChallengeRules ref="refChallengeRules" @add="storeProcess" @remove="refreshProcess" @update="updateRules" :permissions="permissions"/>
                  </CCol>
                </CRow>
                <CRow v-if="challenge.type != 'video' && challenge.type != 'objectives'">
                  <CCol md="12">
                    <ChallengeManagerRules ref="refChallengeManagerRules" @update="updateManagerRules" :permissions="permissions"/>
                  </CCol>
                </CRow>
                <CRow v-if="challenge.type == 'objectives'">
                  <CCol md="12">
                    <ChallengeObjectives ref="refChallengeObjectives" :challenge_id="challenge_id" :permissions="permissions"/>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
            <CCard v-show="tab == 'awards'">
              <CCardBody>
                <CRow>
                  <CCol md="12">
                    <ChallengeAwards ref="refChallengeAwards" @update="updateAwards" :permissions="permissions"/>
                  </CCol>
                </CRow>
                <CRow v-if="challenge.type != 'video'">
                  <CCol md="12">
                    <ChallengeManagerAwards ref="refChallengeManagerAwards" @update="updateManagerAwards" :permissions="permissions"/>
                  </CCol>
                </CRow>                
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    
    <ChallengeWinnersModal ref="checkWinnersModal" @winners="winnersProcess"></ChallengeWinnersModal>
    <ChallengeValidationModal ref="validationsModal" @validations="validationsProcess"></ChallengeValidationModal>
    <ChallengeResetModal ref="challengeResetModal" @reset="resetProcess"></ChallengeResetModal>
    <ChallengeVideoModal ref="challengeVideoModal" @store="storeProcess"></ChallengeVideoModal>
  </div>
</template>
<script>

import store from '../../store'
import challenges_ws from '../../services/challenges';
import account_ws from '../../services/account';
import router from '../../router/index'

import ChallengeResetModal from '../../components/challenges/ChallengeResetModal.vue'
import ChallengeWinnersModal from '../../components/challenges/ChallengeWinnersModal.vue'
import ChallengeValidationModal from '../../components/challenges/ChallengeValidationModal.vue'
import ChallengeVideoModal from '../../components/challenges/ChallengeVideoModal.vue'
import ChallengeQuest from '../../components/challenges/ChallengeQuest.vue'
import ChallengeRules from '../../components/challenges/ChallengeRules.vue'
import ChallengeManagerRules from '../../components/challenges/ChallengeManagerRules.vue'
import ChallengeObjectives from '../../components/challenges/objectives/ChallengeObjectives.vue'
import ChallengeAwards from '../../components/challenges/ChallengeAwards.vue'
import ChallengeManagerAwards from '../../components/challenges/ChallengeManagerAwards.vue'
import ChallengeEntries from '../../components/challenges/ChallengeEntries.vue'
import ChallengeProducts from '../../components/challenges/ChallengeProducts.vue'
import ChallengeSales from '../../components/challenges/ChallengeSales.vue'
import ChallengeAvailable from '../../components/challenges/ChallengeAvailable.vue'
import ChallengeCustomers from '../../components/challenges/ChallengeCustomers.vue'

import YouTubePlayer from 'youtube-player';

export default {
  name: 'ChallengeView',
  components: {
    ChallengeWinnersModal,
    ChallengeValidationModal,
    ChallengeResetModal,
    ChallengeVideoModal,
    ChallengeQuest,
    ChallengeRules,
    ChallengeManagerRules,
    ChallengeObjectives,
    ChallengeAwards,
    ChallengeManagerAwards,
    ChallengeEntries,
    ChallengeAvailable,
    ChallengeCustomers,
    ChallengeProducts,
    ChallengeSales
  },
  data () {
    return {
      tab: 'info',
      fields: [],
      product_fields: [],
      sales_fields: [],
      challenge_id: 0,
      challenge: {
        'type': 'boxes'
      },
      questions: [],
      entries: [],
      has_pendings: 0,
      has_validated: 0,
      products: [],
      availables: [],
      customers: [],
      ranges: [],
      awards: [],
      manager_awards: [],
      has_files: false,
      permissions: null
    }
  },
  mounted: async function() {
    this.loading();

    let challenge_id = await this.$route.params.challenge_id;
    this.challenge_id = challenge_id;
    let responseX = await account_ws.getInfo(); 

    if(responseX.type == "success"){
      this.permissions = responseX.data.user.permissions;
    }

    let response = await challenges_ws.show(this.challenge_id); 

    if(response.type == "success"){
      this.challenge = response.data;
      this.awards = this.challenge.awards;
      this.manager_awards = this.challenge.manager_awards;
      this.ranges = this.challenge.ranges;
    }

    let response2 = await challenges_ws.getQuestions(this.challenge_id);

    if(response2.type == "success"){
      this.questions = response2.data;

      this.fields = [
        {key: 'code', label: 'Ruta', _style: 'font-size: 12px;'},
        {key: 'name', label: 'Nombre', _style: 'font-size: 12px;'},
        {key: 'date', label: 'Fecha', _style: 'font-size: 12px;'},
        {key: 'points', label: 'Puntos', _style: 'font-size: 12px;'},
        {key: 'paid', label: 'Pagado', _style: 'font-size: 12px;'},
        {key: 'actions', label: 'Acciones', class: 'actions', _style: 'font-size: 12px;' },
      ];

      let alias = "";
      if(this.challenge.awards != undefined && this.challenge.awards[0] != undefined){
        alias = this.challenge.awards[0].alias;
      }

      if(alias == undefined || alias == null || alias == ""){
        alias = "Punto|Puntos";
      }
      
      alias = alias.split("|");

      if(this.challenge.type == "boxes_and_customers"){
        this.fields = [
          {key: 'code', label: 'Ruta'},
          {key: 'cedis', label: 'CEDIS'},
          {key: 'name', label: 'Nombre'},
          {key: 'points', label: alias ? alias[1] : 'Puntos'},
          {key: 'paid', label: 'Pagado'},
          {key: 'actions', label: 'Acciones', class: 'actions' },
        ]
      }

      if(this.challenge.type == "boxes" || this.challenge.type == "sales" || this.challenge.type == "customers"){        
        this.fields = [
          {key: 'code', label: 'Ruta'},
          {key: 'cedis', label: 'CEDIS'},
          {key: 'name', label: 'Nombre'},
          {key: 'points', label: alias ? alias[1] : 'Puntos'},
          {key: 'paid', label: 'Pagado'},
          {key: 'actions', label: 'Acciones', class: 'actions' },
        ]
      }

      this.questions.forEach(async (question) => {
        if(question.type == "file" || question.type == "multipleFile"){
          this.fields = [
            {key: 'code', label: 'Ruta'},
            {key: 'name', label: 'Nombre'},
            {key: 'files', label: 'Archivos'},
            {key: 'date', label: 'Fecha'},
            {key: 'points', label: 'Puntos'},
            {key: 'paid', label: 'Pagado'},
            {key: 'actions', label: 'Acciones', class: 'actions' },
          ]
        }
      });
    }

    let response3 = await challenges_ws.getEntries(this.challenge_id);

    if(response3.type == "success"){
      this.entries = response3.data;
      this.has_pendings = response3.has_pendings;
      this.has_validated = response3.has_validated;
    }

    let response4 = await challenges_ws.getAvailables(this.challenge_id);

    if(response4.type == "success"){
      this.availables = response4.data;
    }

    let response5 = await challenges_ws.getProducts(this.challenge_id);

    if(response5.type == "success"){
      this.product_fields = [
        {key: 'product_code', label: 'Código'},
        {key: 'product_name', label: 'Nombre'},
        {key: 'actions', label: 'Acciones', class: 'actions' },
      ];

      this.products = response5.data;
    }

    let response6 = await challenges_ws.getCustomers(this.challenge_id);

    if(response6.type == "success"){
      this.customers = response6.data;
    }

    this.sales_fields = [
        {key: 'date', label: 'Fecha', _style: 'font-size: 12px;'},
        {key: 'product', label: 'Producto', _style: 'font-size: 12px;'},
        {key: 'sname', label: 'Vendedor - Cliente', _style: 'font-size: 12px;'},
        {key: 'boxes', label: 'Cajas', _style: 'font-size: 12px;'},
        {key: 'total', label: 'Monto', _style: 'font-size: 12px;'},
        {key: 'actions', label: 'Acciones', class: 'actions', _style: 'font-size: 12px;'},
    ];

    this.loaded();
  },
  methods: {
    storeModal () {
      this.$refs.challengeVideoModal.storeModal(this.challenge_id);
    },    
    async storeProcess (data) {
      this.loading();
      let response = await challenges_ws.addVideo(data); 

      if(response.type == "success"){
        this.challenge = response.data;
        if(this.tab == 'rules'){
          this.$refs.refChallengeRules.loadChallenge(this.challenge);
        }
      }
      this.loaded();
    },
    async refreshProcess (data) {
      this.challenge = data;
    },
    async updateRules (data) {
      this.loading();
      let response = await challenges_ws.updateRules(data); 

      if(response.type == "success"){
        this.challenge = data.challenge;
        this.awards = this.challenge.awards;
        this.ranges = this.challenge.ranges;

        this.refreshProcess(this.challenge);
      }

      this.showToast(response.type, response.message);
      this.loaded();
    },
    async updateAwards (data) {
      this.loading();
      let response = await challenges_ws.updateAwards(data); 

      if(response.type == "success"){
        this.challenge = response.data;
        this.awards = this.challenge.awards;
        this.ranges = this.challenge.ranges;

        this.refreshProcess(this.challenge);

        this.loaded();
      }

      this.showToast(response.type, response.message);
      
    },
    async updateManagerRules (data) {
      this.loading();
      let response = await challenges_ws.updateManagerRules(data); 

      if(response.type == "success"){
        this.challenge = data.challenge;
        this.awards = this.challenge.awards;
        this.ranges = this.challenge.ranges;

        this.refreshProcess(this.challenge);
      }

      this.showToast(response.type, response.message);
      this.loaded();
    },
    async updateManagerAwards (data) {
      this.loading();
      let response = await challenges_ws.updateManagerAwards(data); 

      if(response.type == "success"){
        this.challenge = response.data;
        this.manager_awards = this.challenge.manager_awards;
        this.ranges = this.challenge.ranges;

        this.refreshProcess(this.challenge);
      }

      this.loaded();

      this.showToast(response.type, response.message);
      
    },
    changeTab (tab) {
      if(this.tab != tab){
        this.tab = tab;

        if(this.challenge.type == "video" && tab == 'info' && this.challenge.videos.length > 0){
          if(!this.player){
            let _this = this;
            setTimeout(function(){
              _this.player = YouTubePlayer('video-player');
              _this.player.loadVideoById(_this.challenge.youtube);
            }, 1000);
          }
        }

        if(this.tab == 'sales'){
          this.$refs.refChallengeSales.loadChallenge(this.challenge);
        }

        if(this.tab == 'rules' && this.challenge.type != 'objectives'){
          this.$refs.refChallengeRules.loadChallenge(this.challenge);
          if(this.challenge.type != 'video'){
            this.$refs.refChallengeManagerRules.loadChallenge(this.challenge);
          }
        }
        if(this.tab == 'rules' && this.challenge.type == 'objectives'){
          this.$refs.refChallengeObjectives.refresh();
        }

        if(this.tab == 'awards'){
          this.$refs.refChallengeAwards.loadChallenge(this.challenge, this.awards);          
          if(this.challenge.type != 'video'){
            this.$refs.refChallengeManagerAwards.loadChallenge(this.challenge, this.manager_awards);
          }          
        }
      }
    },
    showDashboard () {
      router.push({path: '/challenges/'+this.challenge.id+'/dashboard'});
    },
    resetChallengerModal () {
      this.$refs.challengeResetModal.showResetModal(this.challenge.id);
    },
    checkWinnersModal () {
      this.$refs.checkWinnersModal.showWinnersModal(this.challenge_id);
    },
    validationsModal () {
      this.$refs.validationsModal.showValidationsModal(this.challenge.id);
    },
    async resetProcess(id) {
      let response = await challenges_ws.resetChallenge({id: this.challenge.id});
      this.showToast(response.type, response.message);
      if(response.type == "success"){
        this.$emit("refresh", response.data );
        window.location.reload();
      }      
    },
    async winnersProcess(data) {
      this.loading();

      console.log(data);

      let response = await challenges_ws.winnersChallenge({challenge_id: data.challenge_id});
      
      if(response.type == "success"){
        this.entries = response.data;
        this.has_pendings = response.has_pendings;
        this.has_validated = response.has_validated;

        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);

      this.loaded();
    },
    async validationsProcess(id) {
      this.loading();

      let response = await challenges_ws.validationPointsChallenge({challenge_id: this.challenge.id});
      
      if(response.type == "success"){
        this.entries = response.data;
        this.has_pendings = response.has_pendings;
        this.has_validated = response.has_validated;

        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);

      this.loaded();
    },
    async refreshQuestions (items) {
      this.loading();
      this.questions = await items;
      this.loaded();
    },
    async refreshEntries (items) {
      this.loading();
      this.entries = await items;
      this.loaded();
    },
    async refreshProducts (items) {
      this.loading();
      this.products = await items;
      this.loaded();
    },
    async refreshAvailables (items) {
      this.loading();
      this.availables = await items;
      this.loaded();
    },
    async refreshCustomers (items) {
      this.loading();
      this.customers = await items;
      this.loaded();
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    },
    color (value) {
      let $color
      if (value <= 25) {
        $color = 'info'
      } else if (value > 25 && value <= 50) {
        $color = 'success'
      } else if (value > 50 && value <= 75) {
        $color = 'warning'
      } else if (value > 75 && value <= 100) {
        $color = 'danger'
      }
      return $color
    }
  }
}
</script>
